var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeJs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 120,
    viewBox: "0 0 240 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_20",
    "data-name": 20,
    clipPath: "url(#clip-_20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20034",
    "data-name": "Group 20034",
    transform: "translate(35 -141.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M32.114,235a1.32,1.32,0,0,0-.661-1.149l-10.947-6.3a1.29,1.29,0,0,0-.6-.174H19.79a1.309,1.309,0,0,0-.6.174l-10.947,6.3A1.326,1.326,0,0,0,7.576,235L7.6,251.969a.649.649,0,0,0,.33.571.635.635,0,0,0,.657,0l6.506-3.725a1.332,1.332,0,0,0,.662-1.147v-7.926a1.317,1.317,0,0,1,.66-1.145l2.77-1.6a1.315,1.315,0,0,1,.663-.177,1.3,1.3,0,0,1,.658.177l2.769,1.6a1.318,1.318,0,0,1,.661,1.145v7.926a1.335,1.335,0,0,0,.663,1.147l6.5,3.725a.644.644,0,0,0,.661,0,.661.661,0,0,0,.328-.571Z",
    transform: "translate(0 -31.611)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M222.054,180.073a.661.661,0,0,0-.983.577v16.8a.463.463,0,0,1-.694.4l-2.742-1.58a1.323,1.323,0,0,0-1.321,0l-10.952,6.32a1.322,1.322,0,0,0-.661,1.145v12.643a1.324,1.324,0,0,0,.661,1.145l10.951,6.325a1.324,1.324,0,0,0,1.323,0l10.953-6.325a1.324,1.324,0,0,0,.661-1.145V184.864a1.322,1.322,0,0,0-.678-1.155Zm-1.016,32.154a.329.329,0,0,1-.165.286l-3.76,2.168a.332.332,0,0,1-.33,0l-3.76-2.168a.329.329,0,0,1-.165-.286v-4.342a.332.332,0,0,1,.165-.287l3.76-2.172a.332.332,0,0,1,.331,0l3.76,2.172a.331.331,0,0,1,.165.287Z",
    transform: "translate(-131.484 0)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M326.775,239.689a1.322,1.322,0,0,0,.658-1.143v-3.064a1.322,1.322,0,0,0-.658-1.143l-10.881-6.318a1.321,1.321,0,0,0-1.325,0l-10.948,6.32a1.322,1.322,0,0,0-.661,1.145v12.64a1.322,1.322,0,0,0,.668,1.149l10.88,6.2a1.321,1.321,0,0,0,1.3.007l6.581-3.658a.661.661,0,0,0,.008-1.151l-11.017-6.323a.661.661,0,0,1-.332-.573v-3.961a.661.661,0,0,1,.331-.573l3.429-1.977a.66.66,0,0,1,.66,0l3.431,1.977a.66.66,0,0,1,.331.573v3.116a.662.662,0,0,0,.994.572Z",
    transform: "translate(-197.024 -31.918)",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M117.815,227.819a1.323,1.323,0,0,1,1.322,0l10.95,6.319a1.322,1.322,0,0,1,.662,1.145v12.648a1.324,1.324,0,0,1-.661,1.146l-10.95,6.324a1.324,1.324,0,0,1-1.323,0l-10.948-6.324a1.323,1.323,0,0,1-.661-1.146V235.284a1.322,1.322,0,0,1,.662-1.145Z",
    transform: "translate(-65.787 -31.785)",
    fill: "#80bd01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M413.308,255.107a2.164,2.164,0,0,1-1.083-.29l-3.447-2.04c-.514-.288-.263-.39-.094-.449a6.883,6.883,0,0,0,1.559-.709.265.265,0,0,1,.256.02l2.649,1.572a.34.34,0,0,0,.32,0l10.326-5.96a.325.325,0,0,0,.158-.279V235.055a.333.333,0,0,0-.16-.285l-10.321-5.954a.324.324,0,0,0-.318,0l-10.319,5.956a.331.331,0,0,0-.164.283v11.916a.316.316,0,0,0,.163.276l2.828,1.634c1.535.767,2.474-.137,2.474-1.045V236.072a.3.3,0,0,1,.3-.3h1.309a.3.3,0,0,1,.3.3v11.765c0,2.049-1.116,3.223-3.058,3.223a4.417,4.417,0,0,1-2.378-.646l-2.708-1.559a2.181,2.181,0,0,1-1.083-1.884V235.055a2.176,2.176,0,0,1,1.083-1.882l10.326-5.967a2.262,2.262,0,0,1,2.17,0l10.325,5.967a2.179,2.179,0,0,1,1.085,1.882v11.916a2.186,2.186,0,0,1-1.085,1.884L414.4,254.817A2.166,2.166,0,0,1,413.308,255.107Z",
    transform: "translate(-262.296 -31.31)",
    fill: "#80bd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M436.961,263.98c-4.519,0-5.465-2.074-5.465-3.814a.3.3,0,0,1,.3-.3h1.335a.3.3,0,0,1,.3.253c.2,1.359.8,2.045,3.535,2.045,2.175,0,3.1-.492,3.1-1.646,0-.665-.262-1.159-3.643-1.49-2.825-.279-4.573-.9-4.573-3.164,0-2.084,1.756-3.326,4.7-3.326,3.308,0,4.945,1.148,5.152,3.611a.3.3,0,0,1-.3.325h-1.34a.3.3,0,0,1-.29-.233c-.322-1.43-1.1-1.887-3.225-1.887-2.375,0-2.651.827-2.651,1.447,0,.751.326.97,3.533,1.394,3.173.419,4.68,1.013,4.68,3.243C442.109,262.691,440.233,263.98,436.961,263.98Z",
    transform: "translate(-282.759 -48.392)",
    fill: "#80bd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M334.867,261.575a.254.254,0,0,1,.254,0l2.1,1.212a.254.254,0,0,1,.127.22v2.426a.254.254,0,0,1-.127.22l-2.1,1.212a.254.254,0,0,1-.254,0l-2.1-1.212a.254.254,0,0,1-.127-.22v-2.426a.254.254,0,0,1,.127-.22Z",
    transform: "translate(-216.821 -54.396)",
    fill: "#80bd01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(166.675 197.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M489.348,233.471a1.99,1.99,0,1,1-1.99-1.991A2,2,0,0,1,489.348,233.471Zm-3.659-.006a1.669,1.669,0,1,0,1.664-1.663A1.67,1.67,0,0,0,485.689,233.465Zm.921-1.111h.769c.263,0,.78,0,.78.59a.513.513,0,0,1-.422.547c.306.021.327.221.369.505a2.21,2.21,0,0,0,.116.589h-.473c-.011-.105-.085-.674-.085-.705-.031-.126-.074-.189-.231-.189h-.39v.895h-.432Zm.422.979h.347a.3.3,0,0,0,.337-.316c0-.306-.211-.306-.327-.306h-.357Z",
    transform: "translate(-485.368 -231.48)",
    fill: "#80bd01"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/node-js.c609fd1b364d9a57d1bbd356fb25f31f.svg";
export { ForwardRef as ReactComponent };